"use strict";

// Polyfill for NodeList's forEach method -- needed for IE.
// From https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

export class Filter {


    /*
	 * filter using a selection from a Select list
	 *
	 * @param query  The text to search for.
	 * @param data   An array of objects to be inspected.  This may not be the
	 * full set of data if a previous filter has already removed some items.
	 *
	 * @return an array of objects from the data array that pass the filter.
	 *
	 * Context: this is the filter object.
	 */
    filterSelect(query, data) {
		
		(this.msglevel>4) && console.log("filterSelect", data, this);

    	var filter = this, field = filter.fields[0], results;

		query = query || "";
		filter.query = query;   // Used in logging code

		(this.msglevel>2) && console.log("Filtering " + filter.fieldlabel + "='" + query + "'");

		// If there is no query...
		if (query==="") {
			// ...and empty queries are supposed to be processed, return everything...
			if (filter.processNullQuery) {
				return data;
			}
			return [];   // ...otherwise, return nothing.
		}

		results = _.filter(data, function(item) {
			return item[field] === query;
		});

		(this.msglevel>4) && console.log("Filter result, " + results.length + " items", results);

		return results;


	};


    /*
	 * filter using a selection from a Select list
	 *
	 * @param query  The text to search for.
	 * @param data   An array of objects to be inspected.  This may not be the
	 * full set of data if a previous filter has already removed some items.
	 *
	 * @return an array of objects from the data array that pass the filter.
	 *
	 * Context: this is the filter object.
	 */
    filterPropRegExp(query, data) {
		
    	var filter = this, fields = filter.fields, results;

		(this.msglevel>4) && console.log("filterPropSubstring", data, this);

		if (!query.length && this.processNullQuery) {
			return data;
		}

		var reopts = "";
		if (!filter.casesensitive) {
			reopts = "i";
		}

		var regexps = query.map(function(q) {
			return new RegExp(q, reopts);
		});
		
		results = data.filter(function(item) {
			return regexps.some(function(re) {
				return filter.fields.some(function(field) {
					return re.test(item[field]);
				});
			});
		});

		(this.msglevel>4) && console.log("Filter result, " + results.length + " items", results);

		return results;

	};

	

    /*
	 * filter using a selection from a Select list
	 *
	 * @param query  The text to search for.
	 * @param data   An array of objects to be inspected.  This may not be the
	 * full set of data if a previous filter has already removed some items.
	 *
	 * @return an array of objects from the data array that pass the filter.
	 *
	 * Context: this is the filter object.
	 */
    filterMinSubpropertySum(query, data) {
		
    	var filter = this, field = filter.fields[0], results;

		(this.msglevel>4) && console.log("maxSubpropValue", data, this);

		if (!query.length && this.processNullQuery) {
			data.forEach(function(item) {
				item[filter.outputprop] = 0;
			});
			results = data;
			
		} else {

			results = data.filter(function(item) {
				var weights = item[field];

				var sum = query.reduce(function(acc, curr) {
					return acc + (weights[curr] ? parseFloat(weights[curr]) : 0);	
				}, 0);

				item[filter.outputprop] = sum;

				return sum >= filter.minvalue;
			});
			
		}

		(this.msglevel>4) && console.log("Filter result, " + results.length + " items", results);

		return results;

	};

	
    /*
	 * filter using a text search
	 *
	 * @param query  The text to search for.
	 * @param data   An array of objects to be inspected.  This may not be the
	 * full set of data if a previous filter has already removed some items.
	 *
	 * @return an array of objects from the data array that pass the filter.
	 *
	 * Context: this is the filter object.
	 */
    filterText(query, data) {
		(this.msglevel>4) && console.log("filterText", data, this);

    	var filter = this, aRegex=[], opts="", prefix="", suffix="", results, words;

		query = query[0] || "";

		(this.msglevel>2) && console.log("Filtering " + filter.fieldlabel + "='" + query + "'");

		// Build options and optional parts of the regular expressions.
		if (!filter.casesensitive) {
			opts = "i";
		}
		if (filter.matchwordstart) {
			prefix = "\\b";
		}
		if (filter.matchwordend) {
			suffix = "\\b";
		}

		// Build an array of regular expressions to be used to filter entries.
		// If splitquery is true, then each word in the query becomes a regular expression.
		// If splitquery is false, the entire query is turned into one regular expression.
		if (filter.splitquery) {
		    words = query.match(/([^'"\s]\S*|'[^']*'|"[^"]*")/g) || [];
		} else {
			words = [query];
		}

		(this.msglevel>4) && console.log("Words found in query:", words);

		words.forEach(function(word) {

			// Remove leading and trailing quotes
		    if (word.substr(0,1)==="'" || word.substr(0,1)==='"') {
           		word = word.substr(1);
    		}
		    if (word.substr(word.length-1)==="'" || word.substr(word.length-1)==='"') {
   				word = word.substr(0,word.length-1);
		    }

			// Turn the word into a regular expression that matches the word.
			// If the word consisted of just a leading and/or trailing quote, it might be null.
			// There is no need for a regex in this case.
			if (word.length) {
		    	aRegex.push(new RegExp(prefix + _.escapeRegExp(word.trim()) + suffix, opts));
			}

		});

		// Keep the regular expressions on the filter object so the highlight can work
		filter.aRegex = aRegex;

		// If there is no query...
		if (!aRegex.length) {
			// ...and empty queries are supposed to be processed, return everything...
			if (filter.processNullQuery) {
				return data;
			}
			return [];   // ...otherwise, return nothing.
		}

		// Do the filtering.  Include an item in the result set if any of the regex's match.
      	results = _.filter(data, function(item) {
         	for (var i = 0; i < aRegex.length; i++) {

	            if (aRegex[i].test(filter.getStringValue(item))) {
	               return true;
	            }

	        }
        });

		(this.msglevel>4) && console.log("Filter result, " + results.length + " items", results);
      	return results;

	};

	gVals() {
		console.log(`getting state for ${this.name}, ${this.manager.internalstate[this.name]}`);
		return this.manager.internalstate[this.name];
	};
	
	getTextFormValues() {
	
		var result = [];
		
		document.querySelectorAll(this.selector).forEach(function(field) {
			if (field.value) {
				result.push(field.value);
			}	
		});
		
		return result;
	};
	
	setTextFormValues(values) {
	
		document.querySelectorAll(this.selector).forEach((field, i) => {
			if (values.length > i && values[i] !== undefined) {
				field.value = values[i];
			}
		});
	};

	
	getSelectFormValues() {
	
		var result = [];
		
		document.querySelectorAll(this.selector).forEach(function(field) {
			if (field.value) {
				result.push(field.value);
			}	
		});
		
		return result;
	};
	
	setSelectFormValues(values) {
	
		document.querySelectorAll(this.selector).forEach((field, i) => {
			if (values.length > i && values[i] !== undefined) {
				field.value = values[i];
			}
		});
	};
	
	
	getCheckedFormValues() {
	
		var result = [];
		
		document.querySelectorAll(this.selector).forEach(function(field) {
			if (field.checked) {
				result.push(field.value);
			}	
		});
		
		return result;
	};


	setCheckedFormValues(values) {
	
		var result = [];
		
		document.querySelectorAll(this.selector).forEach((field) => {
			field.checked = values.some((v) => field.value === v);
		});
		
		return result;
	};

	filterTrueProperty(query, data) {
		
		if ((!query || !query.length) && this.processNullQuery) {
			return data;
		}
		
		return data.filter(function(d) {
			return query.some(function(q) {
				return d[q];
			});
		});
	};
	

	/* Handle a keyup event from a text input field.
	 *
	 */	
	handleTextKeystroke(evt) {
		let filter = this;

		filter.manager.handleFormChange(evt);

	};

	/* Handle a change event from a select list.
	 *
	 */	
		handleSelectChange(evt) {
			let filter = this;
	
			filter.manager.handleFormChange(evt);
	
		};

	/*
	 *
	 * context: the FilterManager instance
	 */
	constructor(opts) {

	    let fields;

		this.name = opts.name;
		this.selector = opts.selector;
		this.msglevel = opts.msglevel || 0;
		this.el = document.querySelector(this.selector);
		if (!this.el) {
			console.log("Filter: no element matches '" + this.selector + "'.");
			return this;
		}

		
		/* opt.fields can be a single string, an array of strings, or a function.
		 * Create this.getStringValue that is always a function.
		 */
		fields = opts.fields;
		this.fields = fields;
		this.getStringValue = fields;
		if (typeof fields != 'function') { 		 // Hope for a function
			if (typeof fields == 'string') {  	 //...but if it is a string, convert to an array.
				fields = fields.trim().split(/\s*,\s*/);
		    }
			// Fields is now always an array (or it wasn't a string or array coming in)

			this.getStringValue = function(item) {
				var result = [];
				this.fields.forEach(function(f) {
					result.push(item[f]);
				});
				return result.join("\n");
			};

		}
		this.fieldlabel = (typeof this.fields == 'function') ? "(function)" : this.fields;
		this.processNullQuery = opts.processNullQuery;
		this.casesensitive = opts.casesensitive;
		this.outputprop = opts.outputprop;
		this.minvalue = opts.minvalue || 0;
		this.splitquery = opts.splitquery == null /* or undefined */ ? true : opts.splitquery;
		this.getValues = this.gVals;

		this.type = opts.type;  // TODO: needed any more?

		this.inputtype = opts.inputtype || 'text';
		switch(this.inputtype) {
			case "text":
				this.getFormValues = this.getTextFormValues;
				this.setFormValues = this.setTextFormValues;
				this.el.addEventListener('keyup', this.handleTextKeystroke.bind(this));
			break;
			case "radio-checkbox":
				this.getFormValues = this.getCheckedFormValues;
				this.setFormValues = this.setCheckedFormValues;
			break;
			case "select":
				this.getFormValues = this.getSelectFormValues;
				this.setFormValues = this.setSelectFormValues;
				// this.el.addEventListener('change', handleChange.bind(this));
			break;
		}

		this.matchtype = opts.matchtype;
		switch(this.matchtype) {
			case "text":
				this.fnFilterOnly = this.filterText;
			break;
			case "true-property":
				this.fnFilterOnly = this.filterTrueProperty;
			break;
			case "match-property-regexp":
				this.fnFilterOnly = this.filterPropRegExp;
			break;
			case "min-subproperty-sum":
				this.fnFilterOnly = this.filterMinSubpropertySum;
			break;
		}

	};

	// getFilterValue(filtername) {

	// 	var result;   // Leave as undefined
		
	// 	try {
	// 		result = this.internalstate[this.filtermap[filtername].queryparam];
	// 	} catch(e) {
	// 		// Nothing
	// 	}

	// 	return result || [];
	// };

};
